import ControlFactory from '@/Factories/ControlFactory';
import ComponentManager from '@/Management/ComponentManager';
import CheckBoxThreeStateViewModelType from '@/Components/CheckBoxThreeState/CheckBoxThreeStateViewModel';
import CheckBoxType from '@/Components/CheckBoxThreeState/CheckBoxThreeState';

export default class CheckBoxThreeStateFactory extends ControlFactory {

    /**
     *  @override
     */
    control: CheckBoxType;
    private CheckBoxThreeStateViewModel = ComponentManager.getViewModel<typeof CheckBoxThreeStateViewModelType>('CheckBoxThreeStateViewModel');
    private CheckBoxThreeState = ComponentManager.getControl<typeof CheckBoxType>('CheckBoxThreeState');

    /**
     *  @override
     */
    public viewModel: CheckBoxThreeStateViewModelType;
    private jQueryControl: JQuery<HTMLElement>;

    public constructor(params) {
        super(params);
    }

    /**
     *  @override
     */
    public getControl(): JQuery<HTMLElement> {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.viewModel = this.createViewModel(this.createViewModelParameter());

        this.control = this.createControl(this.viewModel);

        let tuple = this.control.getTuple();
        this.jQueryControl = tuple.control;

        this.registerDefaultValidation([this.detailViewItem.name]);

        return this.jQueryControl;
    }

    protected createViewModelParameter(): any {
        let params = {
            factory: this,
            isRequired: this.isRequired,
            isEnabled: this.isEnabled,
            isValid: this.isValid,
            isFocusable: this.isFocusable,
            invalidationText: this.invalidationText,
            isSummaryViewMode: this.isSummaryViewMode,
            isChecked: this.context.genericObject.getObservable(this.detailViewItem.name),
            interacted: false,
            parentLocator: this.locator,
            locator: this.detailViewItem.name,
            tooltip: new this.LabelViewModel({
                ergName: this.detailViewItem.tooltip
            })
        };

        if (this.detailViewItem.useInFilter) {
            $.extend(params, {
                value: this.context.genericObject.getObservable(this.detailViewItem.name, false)
            });
        }

        return params;
    }

    protected createViewModel(parameter: any): CheckBoxThreeStateViewModelType {
        return new this.CheckBoxThreeStateViewModel(parameter);
    }

    protected createControl(viewModel: CheckBoxThreeStateViewModelType): CheckBoxType {
        return new this.CheckBoxThreeState(this.viewModel);
    }

    public getValueForFilter(): any {
        const ret = {};
        ret[this.detailViewItem.name] = this.context.genericObject.getValue(this.detailViewItem.name);
        return ret;
    }

    public getFilterInfo(): any {
        return {
            field: this.detailViewItem.name,
            value: this.viewModel?.getValueAsString() || '',
            nullCheck: this.viewModel?.value() == null
        }
    }
}

ComponentManager.setFactory('CheckBoxThreeState', CheckBoxThreeStateFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');